import React, { FC } from 'react';
import { Typography } from '@duxton-web/ui';

import { Changelog } from '@/common/dto/changelog';
import { formatUTCStringToDateTimeString } from '@/utils/dateTime';

interface OwnProps {
  changelog: Changelog;
}

const TimestampHeader: FC<OwnProps> = ({ changelog }) => {
  return (
    <Typography.Text
      style={{
        marginTop: 2,
      }}
    >
      {`Changes on ${formatUTCStringToDateTimeString(changelog?.updated_at)} (GMT +8)`}
    </Typography.Text>
  );
};

export default TimestampHeader;
